import styled from 'styled-components';

const DivCenter = styled.div`text-align: -webkit-center;align-self: center;`;

const TableRight = (props) => {
    
    return (
     
            <div className='mt-5 grid grid-cols-2 gap-4 sm:grid-cols-2 md:grid-cols-6'>
            <DivCenter className='col-span-2'>
                <img src={props.src}  />
            </DivCenter>
            <div className='col-span-4'>
                <div>
                    <p className='mt-3'>{props.text1}</p>
                    <p className='mt-3'>{props.text2}</p>
                    <p className='mt-3'>{props.text3}</p>
                </div>
            </div>
        </div>
       
    );
}

export default TableRight;